/** Putting the web app on the home screen: the language screen's card, and the Install screen. */
export const install = {
    "install.title": "Put GigSync on your home screen",
    "install.about": "It opens like an app, even with no signal.",
    "install.button": "Install app",
    "install.ios": "Tap Share, then Add to Home Screen.",
    "install.ios_first": "Do it before you sign in: on iPhone, the home-screen app keeps its own data, apart from Safari.",
    "install.later": "Not now",
    "install.screen": "Install GigSync",
    "install.on_iphone": "GigSync on your iPhone",
    "install.on_phone": "GigSync on your phone",
    "install.on_computer": "GigSync on your computer",
    "install.installed": "GigSync is installed: you are in the app now.",
    "install.ios_share": "Tap Share: the square with an arrow at the bottom, or under ⋯.",
    "install.other_share": "Tap Share at the top right, or open this page in Safari.",
    "install.ios_add": "Scroll and choose Add to Home Screen.",
    "install.ios_keep": "Keep Open as Web App on, then tap Add.",
    "install.ios_open": "Open GigSync from your home screen.",
    "install.ios_apart": "Best done before you sign in: on iPhone the home-screen app keeps its own data, apart from Safari, so you sign in again there.",
    "install.android_menu": "Tap ⋮ at the top right of Chrome.",
    "install.android_pick": "Choose Install app, or Add to Home screen.",
    "install.android_open": "Tap Install, then open GigSync from your home screen.",
    "install.computer_icon": "Click the install icon at the right of the address bar, or ⋮ › Cast, save and share › Install page as app.",
    "install.mac_dock": "In Safari's menu bar choose File › Add to Dock.",
    "install.computer_add": "Click Install.",
    "install.mac_add": "Click Add.",
    "install.computer_open": "GigSync opens in its own window and with your apps.",
};
//# sourceMappingURL=install.js.map